module.exports = "{{$ctrl.label}}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/exLabel/exLabel.template.html
// module id = 521
// module chunks = 0